/**
 * Provides the product-specific Vault mark without another icon dependency.
 *
 * The inline, current-color SVG follows surrounding control semantics and can
 * be reused across navigation and settings without embedding presentation
 * policy in image assets.
 */
import type { SVGProps } from 'react'

export function VaultSafeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 8.5V6" />
      <path d="M12 18v-2.5" />
      <path d="M8.5 12H6" />
      <path d="M18 12h-2.5" />
    </svg>
  )
}
